import type {BackendAPITypes} from '../../../../../generated/blueprint.ts';
import type {ArchivedDocumentsOrderByEnum, OrderDirectionEnum} from '../../../../../generated/enums.ts';

export type ArchivedDocument =
    BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody['documents'][number];

export interface ArchivedDocumentsFilters {
    dateFrom: string;
    dateTo: string;
    clientId: string;
    fileName: string;
}

export interface ArchivedDocumentsSorting {
    orderby: ArchivedDocumentsOrderByEnum;
    order: OrderDirectionEnum;
}

export const DEFAULT_ARCHIVED_DOCUMENTS_SORTING: ArchivedDocumentsSorting = {
    orderby: 'created_at',
    order: 'desc',
};
